/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Link } from "react-router-dom";
import { FlexContainer, SVGIcon, Text, theme } from "@nordcloud/gnui";
import { getUpdateReportStatusDisplay } from "../const";
import { UpdateReportDetail } from "../types";
import { buildResourceUpdateStatusLink } from "../utils";

type Props = {
  detail: UpdateReportDetail;
};

export function UpdateReportStatusCell({ detail }: Props) {
  const display = getUpdateReportStatusDisplay(detail.status);
  const label = detail.statusLabel ?? display.label;
  const link =
    detail.eventId && detail.resourceId
      ? buildResourceUpdateStatusLink({
          resourceId: detail.resourceId,
          eventId: detail.eventId,
          eventActionId: detail.eventActionId ?? undefined,
        })
      : undefined;

  return (
    <FlexContainer alignItems="center" gap={theme.spacing.spacing02}>
      <SVGIcon
        name={display.icon}
        color={display.color}
        css={{ flexShrink: 0 }}
      />
      {link ? (
        <Link
          to={link}
          css={{
            fontWeight: theme.fontWeights.regular,
            minWidth: 0,
            overflowWrap: "anywhere",
          }}
        >
          {label}
        </Link>
      ) : (
        <Text
          size="md"
          color={theme.color.text.text01}
          css={{
            fontWeight: theme.fontWeights.regular,
            margin: 0,
            minWidth: 0,
            overflowWrap: "anywhere",
          }}
        >
          {label}
        </Text>
      )}
    </FlexContainer>
  );
}
